import React from 'react';
import TransparentButton from 'components/Button/TransparentButton';

const CloseButton = (
  props: React.PropsWithoutRef<JSX.IntrinsicElements['button']>,
) => (
  <TransparentButton {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31">
      <g fill="none" fillRule="evenodd">
        <rect width="31" height="31" fill="#E9F6FF" rx="15.5" />
        <g stroke="#27A9FE" strokeWidth="2">
          <path d="M0.239 0.239L10.761 10.761" transform="translate(10 10)" />
          <path
            d="M0 0L11 11"
            transform="translate(10 10) rotate(-90 5.5 5.5)"
          />
        </g>
      </g>
    </svg>
  </TransparentButton>
);

export default CloseButton;
